import { Dialog, Tooltip } from '@mui/material';
import React from 'react';
import { ReactComponent as CloseIcon } from "assets/img/svg/CloseIcon.svg"
import ALoader from 'views/pages/manage/common/a-loader';

const JsonDialog = ({
  isOpen,
  handleClose = () => { },
  isLoading,
  jsonData
}) => {

  return (
    <Dialog open={isOpen} fullWidth maxWidth="md">
      {isLoading && <ALoader position="fixed" />}

      <div className='p-3'>
        <div className='d-flex justify-content-between'>
          <h4>JSON Data</h4>
          <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
        </div>

        <div
          style={{
            background: "#f5f5f5",
            padding: "12px",
            borderRadius: "6px",
            maxHeight: "400px",
            overflow: "auto",
            marginTop: "10px"
          }}
        >
          <pre style={{ margin: 0 }}>
            {JSON.stringify(jsonData, null, 2)}
          </pre>
        </div>
      </div>
    </Dialog>
  )
}

export default JsonDialog;